'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _reactIntl = require('react-intl');

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var PerformanceCardData = function (_React$Component) {
  _inherits(PerformanceCardData, _React$Component);

  function PerformanceCardData(props) {
    _classCallCheck(this, PerformanceCardData);

    var _this = _possibleConstructorReturn(this, (PerformanceCardData.__proto__ || Object.getPrototypeOf(PerformanceCardData)).call(this, props));

    _this.tooltipId = "pdpSummaryAnnualizedDistributionRatePopUp";
    _this.renderHeaderRow = _this.renderHeaderRow.bind(_this);
    _this.renderResultsRow = _this.renderResultsRow.bind(_this);
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(PerformanceCardData, [{
    key: 'renderIcon',
    value: function renderIcon(tooltipId) {
      var _this2 = this;

      if (!this.props.tooltipDisclosure || (0, _ramda.isNil)(this.props.tooltipDisclosure)) {
        return null;
      }

      var disclosure = this.props.tooltipDisclosure;
      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide',
          role: 'tooltip',
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId, disclosure));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId, disclosure);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(e, tooltipId, disclosure) {
      var el = e.currentTarget || e.target;
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = 'hidden';
      if (disclosure[tooltipId][0].length > 380) {
        if (this.props.breakpoint > 3) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipContentScroll = 'auto';
        }
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      this.props.tooltip.openTooltip(elOffset, disclosure[tooltipId], null, true, e);
    }
  }, {
    key: 'renderResultsRow',
    value: function renderResultsRow(performance) {
      var _this3 = this;

      var rows = [];
      var shouldShowValueInOneDecimals = _collection_utility.CollectionUtility.includes(this.props.formattingRules, 'PERFORMANCE_DATA_SHOW_IN_ONE_DECIMAL');
      var shouldShowValueInTwoDecimals = _collection_utility.CollectionUtility.includes(this.props.formattingRules, 'PERFORMANCE_DATA_SHOW_IN_TWO_DECIMAL');
      var isSectorAverage = (0, _ramda.isNil)(performance.performanceFactor) ? false : (0, _ramda.startsWith)("Sector average", performance.performanceFactor);
      var isQuartileRanking = performance.performanceFactor === "Quartile ranking";

      _collection_utility.CollectionUtility.forEachIndexed(this.props.labels, function (value, key) {
        var valueWhenDataIsNull = (isSectorAverage || isQuartileRanking) && key === "inception" ? "n/a" : "-";

        var formattedValue = _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToAmountWithPreciseRounding(performance[key], 2, valueWhenDataIsNull, true, false, true), numberFormat: _this3.props.numberFormat });
        if (shouldShowValueInOneDecimals) {
          formattedValue = _number_utility2.default.convertToAmountWithPreciseRounding(performance[key], 1, valueWhenDataIsNull, true, true);
        } else if (shouldShowValueInTwoDecimals) {
          formattedValue = _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToAmountWithPreciseRounding(performance[key], 2, valueWhenDataIsNull, true, true), numberFormat: _this3.props.numberFormat });
        }

        if (isQuartileRanking) {
          formattedValue = (0, _ramda.isNil)(performance[key]) ? valueWhenDataIsNull : performance[key];
        }

        rows.push(_react2.default.createElement(
          'td',
          { key: key, className: 'margin-top-5 text-right print-font-size-13',
            'data-testid': 'performance-tab-data-' + key },
          formattedValue
        ));
      });
      return rows;
    }
  }, {
    key: 'getTitleFromKey',
    value: function getTitleFromKey(key) {
      var title = null;
      if (!(0, _ramda.isNil)(key)) {
        switch (key) {
          case "YEARLY":
            title = "Calendar Year";
            break;
          case "AVERAGE_YIELD":
            title = "Thirty Day Average";
            break;
          case "CUMULATIVE_EMEA":
            title = "Cumulative";
            break;
          case "QUARTERLY_ROLLING":
            title = "Quarterly rolling";
            break;
          case "MONTHLY_ROLLING":
            title = "Monthly rolling";
            break;
          case "CALENDAR_YEAR_EMEA":
            title = "Calendar year";
            break;
          default:
            title = (0, _ramda.concat)((0, _ramda.toUpper)(key.charAt(0)), key.slice(1));
        }
      }
      return title;
    }
  }, {
    key: 'renderPerformanceDataRows',
    value: function renderPerformanceDataRows() {
      var _this4 = this;

      var data = this.props.data;
      var isMonthEndOrQuarterEnd = this.props.tableBodyTest === 'monthly-performance-data' || this.props.tableBodyTest === 'quarterly-performance-data' ? true : false;
      return mapIndexed(function (performance, i) {
        if (!performance || (0, _ramda.isNil)(performance.effectiveDate) && isMonthEndOrQuarterEnd) {
          return null;
        } else {

          var performanceText = performance.performanceFactor;

          if (_collection_utility.CollectionUtility.includes(_this4.props.formattingRules, 'PERFORMANCE_TAB_BENCHMARK_PERFORMANCE_SHOW_CURRENCY') && performance.performanceFactor === 'Benchmark') {
            var benchmark = _this4.props.intl.formatMessage({ id: performance.performanceFactor, defaultMessage: performance.performanceFactor });
            benchmark += _this4.props.intl.formatMessage({ id: "benchmark-in-currency", defaultMessage: "in <CURRENCY>" }).replace("<CURRENCY>", _this4.props.intl.formatMessage({ id: "currency-code-" + _this4.props.currencyCode, defaultMessage: _this4.props.currencyCode }));
            performanceText = benchmark;
          } else {
            performanceText = _string_utility2.default.renderFormattedLabel(performanceText, performance.translationKey);
          }

          if ((performance.performanceFactor === 'Benchmark' || performance.performanceFactor === 'Excess return (geometric)') && !_collection_utility.CollectionUtility.includes(_this4.props.visibleDataPoints, 'PERFORMANCE_TAB_BENCHMARK_PERFORMANCE')) {
            return null;
          }

          return _react2.default.createElement(
            'tr',
            { key: i,
              className: 'padding-vertical-5 category row-divider' },
            _react2.default.createElement(
              'th',
              { scope: 'row', className: 'margin-top-5 print-font-size-13 inlineHeader', 'data-testid': 'performance-tab-data-label' },
              performanceText
            ),
            _this4.renderResultsRow(performance)
          );
        }
      }, data);
    }
  }, {
    key: 'renderHeaderRow',
    value: function renderHeaderRow() {
      var _this5 = this;

      var row = [_react2.default.createElement(
        'td',
        { key: 'initial', 'data-testid': 'performance-table-title', className: 'tag' + (this.props.isFlatMode ? " text-left" : "") },
        this.props.isFlatMode ? this.props.title : null,
        ' ',
        this.props.isFlatMode ? PerformanceCardData.getAsOfDate(this.props.data) : null
      )];
      mapIndexed(function (value, key) {
        row.push(_react2.default.createElement(
          'th',
          { key: key, 'data-testid': 'performance-table-header',
            className: 'tag white-space-nowrap print-word-wrap print-font-size-14 text-right' },
          value,
          value != null && value.key === 'pdp-performance-card-annualized-dist-rate' ? _this5.renderIcon(_this5.tooltipId) : null
        ));
      }, this.props.labels);

      return row;
    }
  }, {
    key: 'renderRollingPerformanceRow',
    value: function renderRollingPerformanceRow(performance) {
      var _this6 = this;

      var rows = [];
      mapIndexed(function (value, key) {
        var formattedValue = _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(value), numberFormat: _this6.props.numberFormat });
        rows.push(_react2.default.createElement(
          'td',
          { key: key, className: 'margin-top-5 text-right print-font-size-13',
            'data-testid': 'performance-tab-data-' + key },
          formattedValue
        ));
      }, performance.values);
      return rows;
    }
  }, {
    key: 'renderRollingPerformanceDataRows',
    value: function renderRollingPerformanceDataRows() {
      var _this7 = this;

      var data = this.props.data.rollingPerformanceData;
      return mapIndexed(function (performance, i) {
        if (!performance) {
          return null;
        } else if ((performance.performanceFactor === 'Benchmark' || performance.performanceFactor === 'Excess return (geometric)') && !_collection_utility.CollectionUtility.includes(_this7.props.visibleDataPoints, 'PERFORMANCE_TAB_BENCHMARK_PERFORMANCE')) {
          return null;
        } else {
          return _react2.default.createElement(
            'tr',
            { key: i,
              className: 'padding-vertical-5 category row-divider' },
            _react2.default.createElement(
              'td',
              { className: 'margin-top-5 print-font-size-13', 'data-testid': 'performance-tab-data-label-' + i },
              _string_utility2.default.renderFormattedLabel(performance.performanceFactor, performance.translationKey)
            ),
            _this7.renderRollingPerformanceRow(performance)
          );
        }
      }, data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          index = _props.index,
          activeReturnType = _props.activeReturnType,
          tableBodyTest = _props.tableBodyTest,
          activeTab = _props.activeTab,
          key = _props.key;

      var tableDisplay = index === activeReturnType || this.props.isFlatMode ? "display-block print-display" : "display-none print-display";
      if (this.props.isFlatMode) {
        tableDisplay += " margin-bottom-20";
      }
      var printTitle = this.getTitleFromKey(this.props.printTitle);
      var date = PerformanceCardData.getAsOfDate(data);

      return _react2.default.createElement(
        'div',
        { className: '' + tableDisplay, 'aria-labelledby': key },
        _react2.default.createElement(_table_component2.default, {
          date: date,
          printTitle: printTitle,
          tableHeaders: this.renderHeaderRow(),
          tableHeadersStyle: { "textAlign": "right" },
          tableRows: this.props.tableBodyTest === 'quarterly-rolling-performance-data' || this.props.tableBodyTest === 'monthly-rolling-performance-data' ? this.renderRollingPerformanceDataRows() : this.renderPerformanceDataRows(),
          tableBodyTest: tableBodyTest,
          activeTab: activeTab,
          activeReturnType: activeReturnType,
          breakpoint: this.props.breakpoint,
          ariaLabelledby: 'performance-card-header-label'
        }),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'print-' + printTitle + '-large-disclosure', className: 'caption margin-bottom-15 text-justified position-relative print-display-inline-block', style: { "display": "none" } },
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.props.largeTextDisclosure) } })
        ),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'print-' + printTitle + '-disclosures', className: 'disclosure font-light disclaimer font-slate-grey print-display', style: { "display": "none" } },
          !(0, _ramda.isNil)(this.props.disclosure) && mapIndexed(function (disclosure, index) {
            return _react2.default.createElement('div', { className: 'margin-bottom-15 text-justified', key: index,
              dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
          }, this.props.disclosure || [])
        )
      );
    }
  }], [{
    key: 'getAbsZero',
    value: function getAbsZero(amount) {
      return amount === '-0.0' ? '0.0' : amount;
    }
  }, {
    key: 'getAsOfDate',
    value: function getAsOfDate(data) {
      return (0, _ramda.isNil)(data) || (0, _ramda.length)(data) < 1 || !data[0] ? "" : _date_formatter2.default.getLocalFormattedDate(data[0].effectiveDate);
    }
  }]);

  return PerformanceCardData;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(PerformanceCardData, { withRef: true });